const API_BASE = '/api'

async function request(endpoint, options = {}) {
  const url = `${API_BASE}${endpoint}`
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  }

  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body)
  }

  const response = await fetch(url, config)

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }))
    throw new Error(error.message || `HTTP ${response.status}`)
  }

  return response.json()
}

// Puzzle API
export const puzzleApi = {
  create: (data) => request('/puzzles', { method: 'POST', body: data }),

  get: (id) => request(`/puzzles/${id}`),

  update: (id, data) => request(`/puzzles/${id}`, { method: 'PUT', body: data }),

  publish: (id, creatorName) => request(`/puzzles/${id}/publish`, {
    method: 'POST',
    body: { creatorName }
  }),

  list: (limit = 20) => request(`/puzzles?limit=${limit}`),

  check: (id, cells) => request(`/puzzles/${id}/check`, {
    method: 'POST',
    body: { cells }
  }),

  reveal: (id, type, row, col, direction) => request(`/puzzles/${id}/reveal`, {
    method: 'POST',
    body: { type, row, col, direction }
  }),

  getLeaderboard: (id) => request(`/puzzles/${id}/leaderboard`),
}

// Solve API
export const solveApi = {
  start: (puzzleId, solverName) => request(`/puzzles/${puzzleId}/start`, {
    method: 'POST',
    body: { solverName }
  }),

  update: (solveId, data) => request(`/solves/${solveId}`, {
    method: 'PUT',
    body: data
  }),

  complete: (solveId, solveTime) => request(`/solves/${solveId}/complete`, {
    method: 'POST',
    body: { solveTime }
  }),

  get: (solveId) => request(`/solves/${solveId}`),
}
